/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { downloadManagementReports } from '../../lib/rest/managementReportAPIClient'
import { useQuery } from '@tanstack/react-query'
import { Button, ButtonProps } from '@mantine/core'
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload'

export type DownloadReportsButtonProps = ButtonProps & {
  disabled?: boolean,
  queryFilter?: {
    year?: number,
    estateId?: number,
    customerId?: number,
    leaseId?: number,
    ids?: number[]
  }
}

function DownloadReportsButton (props: DownloadReportsButtonProps) {
  const { disabled, queryFilter, ...others } = props

  const downloadQuery = useQuery({
    enabled: false,
    queryKey: ['downloadManagementReports', queryFilter],
    queryFn: () => downloadManagementReports(queryFilter)
  })

  return (
    <Button
      disabled={disabled || downloadQuery.isFetching}
      {...others}
      loading={downloadQuery.isFetching}
      onClick={() => {
        downloadQuery.refetch()
      }}
    >
      <FontAwesomeIcon
        fixedWidth
        icon={faDownload}
      />
    </Button>
  )
}

export default DownloadReportsButton
